module.exports = __webpack_public_path__ + "build/desktop/a/img/bonus-miles-airplane.014158e25924d3d6dad6b714deb52cda.svg";